import clsx from 'clsx';
import SpiritoryLabel from './SpiritoryLabel';
import React from 'react';
import { BiErrorCircle } from 'react-icons/bi';

export default function SpiritoryTextarea(
  props: React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > & {
    label?: string;
    error?: string;
  }
) {
  const { label, error, ...rest } = props;

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-w-full">
      {label && (
        <SpiritoryLabel htmlFor={props.id} required={props.required}>
          {label}
        </SpiritoryLabel>
      )}
      <div>
        <textarea
          {...rest}
          className={clsx(
            'tw-w-full tw-py-2.5 tw-border tw-border-solid tw-border-platinum-gray tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-outline-none focus:tw-border-2 focus:tw-ring-2 tw-font-medium tw-font-plusJakartaSans tw-leading-[22.68px] tw-text-[#232323]',
            'focus:tw-border-main-shades-500 focus:tw-ring-main-shades-500',
            'tw-px-4 tw-rounded-xl'
          )}
        />
        {error && (
          <div className="tw-flex tw-items-center tw-gap-1 tw-text-red-500 tw-text-xs tw-mt-1">
            <BiErrorCircle className="tw-mt-0.5" /> {error}
          </div>
        )}
      </div>
    </div>
  );
}
